import { createContext } from "react";



const UserContext = createContext({
  email:''
});

export default UserContext;